import React, { useState } from 'react';
import '../../styles/Modal.css';

const AddUserModal = ({ onClose, onSubmit, districts }) => {
  const [formData, setFormData] = useState({
    email: '',
    displayName: '',
    role: 'Candidate',
    districtIds: [],
    sendWelcomeEmail: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDistrictChange = (districtId) => {
    setFormData(prev => ({
      ...prev,
      districtIds: prev.districtIds.includes(districtId)
        ? prev.districtIds.filter(id => id !== districtId)
        : [...prev.districtIds, districtId]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Validation
      if (!formData.email || !formData.displayName) {
        throw new Error('Please fill in all required fields');
      }

      if ((formData.role === 'dCOM' || formData.role === 'dCOM Member') && formData.districtIds.length === 0) {
        throw new Error('Please select at least one district for dCOM users');
      }

      await onSubmit(formData);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Add New User</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>


          <div className="form-group">
            <label htmlFor="displayName">Display Name *</label>
            <input
              type="text"
              id="displayName"
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="role">Role *</label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              disabled={loading}
            >
              <option value="Candidate">Candidate</option>
              <option value="dCOM">dCOM</option>
              <option value="dCOM Member">dCOM Member</option>
              <option value="Admin">Admin</option>
            </select>
          </div>

          {(formData.role === 'dCOM' || formData.role === 'dCOM Member') && (
            <div className="form-group">
              <label>Districts * (Select one or more)</label>
              <div className="district-checkboxes">
                {districts
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(district => (
                    <label key={district.id} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={formData.districtIds.includes(district.id)}
                        onChange={() => handleDistrictChange(district.id)}
                        disabled={loading}
                      />
                      <span className="checkbox-text">{district.name}</span>
                    </label>
                  ))}
              </div>
              <small className="form-help">
                Selected: {formData.districtIds.length} district{formData.districtIds.length !== 1 ? 's' : ''}
              </small>
            </div>
          )}

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="sendWelcomeEmail"
                checked={formData.sendWelcomeEmail}
                onChange={(e) => setFormData(prev => ({ ...prev, sendWelcomeEmail: e.target.checked }))}
                disabled={loading}
              />
              <span className="checkbox-text">Send welcome email with setup instructions</span>
            </label>
            <small className="form-help">
              The user will receive an email with instructions to set their password and access the system.
            </small>
          </div>

          <div className="form-info">
            <p><strong>Note:</strong> The user will be created without a password. They will receive a welcome email with instructions to set up their account and access the system.</p>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
